// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);


import App from './App'
import router from './router'
import store from './store'
import api from '../common/api.js'



import './assets/css/reset.css'
import './assets/css/global.css'
import './assets/fonts/iconfont.css'

import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts;



import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'

Vue.use(VXETable)
VXETable.interceptor.add('event.clearActived', (params, event) => {
  // ⽐如点击了某个组件的弹出层⾯板之后，此时被激活单元格不应该被⾃动关闭，通过返回  false
  // 可以阻⽌默认的⾏为。
  // if (event.target.className.indexOf('el-popper') > -1) {
  return false
  // }
})
//拖拽组件
import vuedraggable from 'vuedraggable'
Vue.component('vuedraggable', vuedraggable)

//二次封装对话框组件
import xPopup from './components/x-popup.vue'
Vue.component('xPopup', xPopup)
import xButton from './components/xButton.vue'
Vue.component('xButton', xButton)
import Time from './components/Time.vue'
Vue.component('Time', Time)
import xSelectTree from './components/x-select-tree.vue'
Vue.component('xSelectTree', xSelectTree)
import clsManage from './components/cls_manage.vue'
Vue.component('clsManage', clsManage)
// 请求
import axios from 'axios';
Vue.prototype.axios = axios

Vue.prototype.api = api

Vue.config.productionTip = false

//eventBus
import eventBus from './assets/js/bus.js';
Vue.prototype.eventBus = eventBus;

//全局option
import globalOption from './assets/js/globalOption.js';
Vue.prototype.globalOption = globalOption;
/* eslint-disable no-new */
//表格导出
Vue.prototype.fExportDataEvent = async (table, qxName) => {
  let resPower = await Vue.prototype.api.smCommon.fGetSmMenuQx(qxName)
  // console.log(vm)
  console.log(resPower.resolve)
  if (resPower.resolve == false) {
    return Vue.prototype.$message('没有' + qxName + '的权限')
  }
  //由于外部取不到table 所以需要通过函数调用用时传参 来找到该表格
  table.exportData({
    type: 'csv'
  })

}
//线上环境去掉console.log
if (process.env.NODE_ENV === 'production') {
  if (window) {
    window.console.log = function() {};
  }
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js